var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 600,
    viewBox: "0 0 1600 600",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#071228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#05263f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 600,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeOpacity: 0.06,
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,220 C160,200 320,260 480,240 C640,220 800,280 960,260 C1120,240 1280,300 1440,280 C1600,260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,340 C160,320 320,380 480,360 C640,340 800,400 960,380 C1120,360 1280,420 1440,400 C1600,380"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 0.02
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 120,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 160,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 200,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 240,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 280,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.5e4eca5031bb79355bc8e7df11b39fe3.svg";
export { ForwardRef as ReactComponent };